import Button from 'components/button/button.component'
import {
    IUseUserAccessForm,
    useUserAccessForm,
} from './user-access-form.service'
import { FormikProvider } from 'formik'
import './user-access-form.style.css'
import FormInput from 'components/form-input/form-input.component'
import FormDropdown from 'components/form-dropdown/form-dropdown.component'
import FormTextArea from 'components/form-textarea/form-textarea.component'
import SelectModuleModal from './modal/select-module-modal.component'

export default function UserAccessForm({
    isNew,
    isProfilePage,
}: IUseUserAccessForm) {
    const {
        formikModule,
        city,
        moduleModalService,
        province,
        nav,
        getCityDropdown,
        getProvinceDropdown,
    } = useUserAccessForm({ isNew, isProfilePage })
    const label = isNew ? 'CREATE USER' : 'UPDATE USER'
    const buttonLabel = isNew ? 'CREATE USER' : 'UPDATE USER'
    const cancelButtonLabel = isNew ? 'CANCEL CREATE' : 'CANCEL UPDATE'

    return (
        <>
            <div className={`container-global user-access`}>
                <div className="border-b themes-border-color">
                    <div className="p-4 text-size-S font-bold">{label}</div>
                </div>

                {/* Form */}
                <div className="content">
                    <FormikProvider value={formikModule}>
                        <div className="w-full">
                            <div className="text-size-S font-bold mb-3">
                                User Profile
                            </div>
                            <FormInput
                                label="FULL NAME"
                                placeholder="Enter User Full Name"
                                name={'fullName'}
                            />
                            <FormInput
                                label="JOB TITLE"
                                placeholder="Enter User Job Title"
                                name={'jobTitle'}
                            />
                            <FormInput
                                label="JOB CATEGORY"
                                placeholder="Enter User Job Category"
                                name={'jobCategory'}
                            />

                            <div className="text-size-S font-bold mb-3">
                                User Account
                            </div>
                            <FormInput
                                label="EMAIL"
                                placeholder="Enter User Email"
                                name={'email'}
                            />
                            <FormInput
                                label="USERNAME"
                                placeholder="Enter Username"
                                name={'username'}
                            />

                            <div className="flex gap-3 justify-between mb-3">
                                <div className="flex-grow leading-tight t">
                                    <div className="text-size-S font-bold">
                                        ROLE
                                    </div>
                                    <div className="text-size-XS leading-tight themes-text-gray-v4">
                                        Adjust on what you would like to display
                                        and hide on the portal, disable or
                                        enable to change your portal module. You
                                        can add/edit roles in settings.
                                    </div>
                                </div>
                                <div
                                    className="flex-initial flex items-center justify-end text-size-S w-[240px] cursor-pointer"
                                    onClick={() =>
                                        moduleModalService.openModalHandling()
                                    }
                                >
                                    <i className="ri-edit-line mr-2 -mt-1" />
                                    SET UP ROLE
                                </div>
                            </div>
                            <FormDropdown
                                dropDownIndicator={true}
                                name="role"
                                label="Role"
                                options={[
                                    {
                                        label: 'Admin',
                                        value: 'admin',
                                    },
                                    {
                                        label: 'Regular User',
                                        value: 'Regular User',
                                    },
                                ]}
                            />
                            <FormDropdown
                                dropDownIndicator={true}
                                name="site"
                                label="Site"
                                isMultiSelect={true}
                                isSearchable={true}
                                options={[
                                    {
                                        label: 'Kuta Site, Bali',
                                        value: 'Kuta Site, Bali',
                                    },
                                    {
                                        label: 'Sanur Site, Bali',
                                        value: 'Sanur Site, Bali',
                                    },
                                ]}
                            />
                        </div>
                        <div className="w-full">
                            <div className="text-size-S font-bold mb-3">
                                User Address (Optional)
                            </div>
                            <div className="flex gap-2 w-full">
                                <div className="w-full">
                                    <FormDropdown
                                        name="country"
                                        label="Country"
                                        options={[
                                            {
                                                label: 'Indonesia',
                                                value: 'Indonesia',
                                            },
                                        ]}
                                        dropDownIndicator={true}
                                        onClick={() => {
                                            getProvinceDropdown()
                                        }}
                                        isSearchable={true}
                                    />
                                </div>
                                <div className="w-full">
                                    <FormDropdown
                                        name="province"
                                        label="Province"
                                        options={province}
                                        dropDownIndicator={true}
                                        onClick={(data) => {
                                            const val = data?.value
                                            if (!val) return
                                            getCityDropdown(val as string)
                                        }}
                                        isSearchable={true}
                                    />
                                </div>
                                <div className="w-full">
                                    <FormDropdown
                                        name="city"
                                        label="City"
                                        options={city}
                                        dropDownIndicator={true}
                                        isSearchable={true}
                                    />
                                </div>
                            </div>
                            <FormTextArea
                                name="address"
                                label="Address Details"
                                rows={3}
                            />

                            <div className="w-full">
                                <div className="text-size-S font-bold mb-3">
                                    User Contact (Optional)
                                </div>
                                <div className="flex gap-2 w-full">
                                    <div className="w-full">
                                        <FormInput
                                            name="mobilePhoneNumber"
                                            label="Mobile Phone Number"
                                        />
                                    </div>
                                    <div className="w-full">
                                        <FormInput
                                            name="homePhoneNumber"
                                            label="Home Phone Number"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-size-S font-bold mb-3">
                                    Emergency Contact (Optional)
                                </div>
                                <div className="flex gap-2 w-full">
                                    <div className="w-full">
                                        <FormInput
                                            name="emergencyContactNumber"
                                            label="Emergency Phone Number"
                                        />
                                    </div>
                                    <div className="w-full">
                                        <FormInput
                                            name="emergencyPhoneNumber"
                                            label="Emergency Phone Number"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FormikProvider>
                </div>

                {/* Button */}
                <div className="flex justify-between p-4 border-t">
                    <Button
                        onClick={() => {
                            nav(-1)
                        }}
                        type="button"
                        label={cancelButtonLabel}
                    />
                    <Button
                        type="button"
                        onClick={async () => {
                            formikModule.submitForm()
                        }}
                        variant="brand"
                        label={buttonLabel}
                    />
                </div>
            </div>

            <SelectModuleModal
                formikModule={formikModule}
                modalService={moduleModalService}
                submitHandling={(data) => {
                    console.log(data)
                }}
            />
        </>
    )
}
